<template>
  <div class="payment">
    <!-- <div class="promotion" v-if="namePlan === 'AN1HO' && !getEmailIndication">
      <a @click="havePromotionCode = !havePromotionCode">Possui um código promocional? Clique aqui!</a>
      <div class="check-code" v-if="havePromotionCode">
        <base-input-text
          v-model="discountCoupon"
          type="text"
          placeholder="PROMO123"
          block
        />
        <base-button success @click="checkPromotion" style="height: 48px">
          Aplicar
        </base-button>
      </div>
    </div> -->

    <div class="mt-4" >
      <section class="mb-2 coupon-box" v-if="namePlan != 'MO1HO'">
        <button
          type="button"
          class="coupon-toggle"
          :aria-expanded="showCoupon ? 'true' : 'false'"
          @click="showCoupon = !showCoupon"
        >
          <strong>Possui um cupom de indicação/desconto?</strong>
          <b-icon :icon="showCoupon ? 'chevron-up' : 'chevron-down'"></b-icon>
        </button>

        <b-collapse v-model="showCoupon" class="coupon-body">
          <section class="mb-2 d-flex align-items-end  justify-content-between">
            <section class="w-75">
              <label for="emailReferralCoupon">
                <strong>Cupom de indicação/desconto</strong>
              </label>
              <b-form-input
                id="emailReferralCoupon"
                v-model="emailReferral"
                placeholder="Digite o cupom de indicação/desconto"
                type="email"
                class="form-control"
              >
              </b-form-input>
            </section>

            <section class="w-25 pl-2">
              <b-overlay
                :show="loadingIsEligibleForReferralBonusAfterWarranty"
                rounded
                opacity="0.7"
                spinner-small
                spinner-variant="primary"
                class="w-100"
              >
                <b-button
                  @click="isEligibleForReferralBonusAfterWarranty()"
                  :disabled="!emailReferral"
                  variant="success"
                  class="w-100"
                >
                  Adicionar cupom
                </b-button>
              </b-overlay>
            </section>
          </section>

          <b-alert
            show
            variant='danger'
            :class='{ hidden: !errors }'
          >
            {{ errors }}
          </b-alert>

          <b-alert
            show
            variant='success'
            :class='{ hidden: !message }'
          >
            <span v-html="message"></span>
          </b-alert>
        </b-collapse>
      </section>

      <strong>
        Escolha abaixo a opção desejada quanto à forma de pagamento:
      </strong>
      <div class='w-100 d-flex flex-wrap justify-content-between my-4'>
        <button
          @click="setMethod('bank_slip')"
          :class="payment.method === 'bank_slip' ? 'hits_select ':'hits_no_select'"
        >
          <span>Boleto bancário e PIX</span>
        </button>

        <button
          @click="setMethod('credit_card')"
          :class="payment.method === 'credit_card' ? 'hits_select ':'hits_no_select'"
        >
          <span>Cartão de crédito</span>
        </button>
      </div>

      <div v-if="payment.method === 'bank_slip'" class="hits_description">
        <strong >
          Pagamento via PIX:
        </strong>
        <span>
                    O acesso à plataforma HO Fácil Web é liberado automaticamente em até 30 minutos após a confirmação do pagamento.
                  </span><br/><br/>

        <strong>
          Pagamento via boleto bancário:
        </strong>
        <span>
                    O acesso é liberado automaticamente após a compensação do pagamento, que pode levar de <strong>24 a 72 horas</strong>, dependendo do banco.
                  </span><br/>
        <span>
                    Se o boleto for pago por <strong>agendamento</strong>, o prazo de até 72 horas começa a contar a partir da <strong>data efetiva do pagamento</strong>.
                  </span>
      </div>

      <div v-if="payment.method === 'credit_card'" class="hits_description">
                  <span>
                    O acesso à plataforma HO Fácil Web é liberado automaticamente assim que o pagamento
                    é aprovado pela operadora do cartão. Esse processo pode levar até <strong>15 minutos</strong>.
                  </span>
      </div>
    </div>

    <div
      class="credit_card-form"
      v-if="payment.method === 'credit_card'"
    >
      <div class="rows_2">
        <div>
          <label>Nome impresso no cartão</label>
          <base-input-text
            v-model="v$.payment.data.full_name.$model"
            type="text"
            block
            placeholder="Nome impresso no cartão"
            :error="getError(v$.payment.data.full_name)"
          />
        </div>

        <div>
          <label>Número</label>
          <base-input-text
            v-model="v$.payment.data.number.$model"
            type="text"
            block
            placeholder="0000 0000 0000 0000"
            v-mask="'#### #### #### ####'"
            :error="getError(v$.payment.data.number)"
          />
        </div>
      </div>

      <div class="validity mt-2">
        <div>
          <label>Mês</label>
          <base-input-select
            v-model="v$.payment.data.month.$model"
            type="text"
            placeholder="Mês"
            class="w-100"
            :options="monthOptions"
          />
        </div>

        <div>
          <label>Ano</label>
          <base-input-select
            v-model="v$.payment.data.year.$model"
            type="text"
            placeholder="Ano"
            class="w-100"
            :options="yearOptions()"
          />
        </div>

        <div class="d-flex">
          <div>
            <label>Código de Segurança</label>
            <base-input-text
              v-model="v$.payment.data.cvv.$model"
              type="text"
              placeholder="000"
              v-mask="['###', '####', '#####']"
            >
              <template #icon-label>
                <base-tooltip>
                  <template #body>
                    <i class="fa fa-info-circle"/>
                  </template>
                  <template v-slot:message>
                    O código de segurança fica impresso no verso do cartão de crédito.
                  </template>
                </base-tooltip>
              </template>
            </base-input-text>
          </div>
          <div class="cc-back">
            <img src="../../../../assets/images/cc-icon.png"/>
          </div>
        </div>

      </div>

      <div class="mt-2" v-if="installmentOptions.length > 0">
        <label>Quantidade de parcelas</label>
        <base-input-select
          v-model="v$.payment.data.installments.$model"
          type="text"
          placeholder="Selecione a quantidade de parcelas"
          :options="installmentOptions"
          :error="getError(v$.payment.data.installments)"
          _key="value"
          _value="text"
        />
      </div>
    </div>

    <div class="buttons">
      <base-button
        class='nav-btn'
        dark
        @click="$emit('back-step')"
      >
        Voltar
      </base-button>
      <b-overlay
        :show="loading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block"
      >
        <base-button
          :disabled="!canNext()"
          class='nav-btn'
          @click="handleSubmitPaymentMethod"
        >
          Próximo
        </base-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { getYear } from 'date-fns'
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import { required, minLength, maxLength } from '@/utils/validators'
import IUGU from '@/services/iugu'

export default {
  components: { },
  name: 'Payment',
  props: {
    installmentOptions: { type: Array, required: true },
    namePlan: { type: String, required: true }
  },
  directives: { mask },
  setup () {
    return { v$: useVuelidate() }
  },
  computed: {
    ...mapGetters('checkout2', {
      billingData: 'getBillingData',
      payment: 'getPayment',
      promotion: 'getPromotion',
      isCreditCard: 'getIsCreditCard',
      getPlan: 'getPlan',
    }),
    ...mapGetters('promocodes', {
      discount: 'discount',
    }),
    user() {
      return this.$store.getters['user/current']
    },
    getEmailIndication() {
      return this.$store.getters['checkout2/getEmailIndication']
    },
    errors() {
      return this.$store.getters['access/error']
    },
    message() {
      return this.$store.getters['access/message']
    },
  },
  data(){
    return {
      havePromotionCode: false,
      showCoupon: false,
      loading: false,
      loadingIsEligibleForReferralBonusAfterWarranty: false,
      emailReferral: null,
      discountCoupon: '',
      monthOptions: [
        { _id: '1', value: '1 - Janeiro'},
        { _id: '2', value: '2 - Fevereiro'},
        { _id: '3', value: '3 - Março'},
        { _id: '4', value: '4 - Abril'},
        { _id: '5', value: '5 - Maio'},
        { _id: '6', value: '6 - Junho'},
        { _id: '7', value: '7 - Julho'},
        { _id: '8', value: '8 - Agosto'},
        { _id: '9', value: '9 - Setembro'},
        { _id: '10', value: '10 - Outubro'},
        { _id: '11', value: '11 - Novembro'},
        { _id: '12', value: '12 - Dezembro'},
      ],
      methodsOptions: [
        { key: 'bank_slip', value: 'Boleto bancário e PIX'},
        { key: 'credit_card', value: 'Cartão de crédito'},
      ],
    }
  },
  validations: {
    payment: {
      method: { required },
      data: {
        full_name: { required },
        first_name: { },
        last_name: { },
        number: { required, minLength: minLength(18) },
        month: { required },
        year: { required },
        cvv: { required, minLength: minLength(3), maxLength: maxLength(5) },
        installments: { required }
      }
    },
  },
  methods: {
    ...mapActions('checkout2', {
      handleSetPromotion: 'handleSetPromotion',
      handleSetPayment: 'handleSetPayment',
      handleGetTokenCreditCard: 'handleGetTokenCreditCard',
      handleSetAlertDetails: 'handleSetAlertDetails',
      handleResetAlertDetails: 'handleResetAlertDetails',
      handleSetMethod: 'handleSetMethod',
      handleSetEmailReferral: 'handleSetEmailReferral',
    }),
    ...mapActions('promocodes', {
      getPromotion: 'getPromo',
    }),
    ...mapActions('userActionLogs', {
      createUserActionLogs: 'createUserActionLogs',
    }),
    ...mapActions('user', {
      handleIsEligibleForReferralBonusAfterWarranty: 'handleIsEligibleForReferralBonusAfterWarranty',
    }),
    async setMethod(method){
      await this.handleSetMethod(method)
    },
    getError(value){
      if(value.$errors.length > 0){
        return value.$errors[0].$message
      }
      return ''
    },
    yearOptions(){
      const now = new Date()
      const currentYear = getYear(now)
      const yearOptions = []
      const CURRENT_YEAR_ADD_15_YEARS = currentYear + 15

      for(let year = currentYear; year <= CURRENT_YEAR_ADD_15_YEARS; year += 1){
        yearOptions.push({
          _id: year,
          value: year
        })
      }
      return yearOptions
    },
    selectPaymentMethod(method){
      if(method === 'bank_slip'){
        this.handleSetPayment({
          method,
          data: {
            installments: 1
          }
        })
      } else if(method === 'credit_card') {
        this.handleSetPayment({
          method,
          data: {
            full_name: '',
            first_name: '',
            last_name: '',
            number: '',
            month: '',
            year: '',
            cvv: '',
            installments: 1
          }
        })
      }
    },
    canNext(){
      if(!this.payment.method) return false

      if(this.isCreditCard) {
        if(this.v$.payment.data.$invalid) return false
      }

      return true
    },
    async handleSubmitPaymentMethod(){
      this.loading = true;
      if(this.payment.method === "credit_card"){
        const response = await this.handleGetTokenCreditCard()

        if(response.error || response.token.error) {
          await this.handleSetAlertDetails({
            open: true,
            message: response.error ? response.error : response.token.error,
            type: 'danger',
          })
          const payload = {
            sent: '-',
            status: 'failed',
            responseError: response ? response : '-',
            user: this.user ? this.user : '-',
          }
          await this.$api
            .post('users/sendErrorTokenCardMail', payload)
            .then((res) => { })
            .catch(() => {})
          this.loading = false;
          return
        }
        const payload = {
          sent: '-',
          status: 'success',
          responseError: '-',
          user: this.user ? this.user : '-',
        }
        await this.$api
          .post('users/sendErrorTokenCardMail', payload)
          .then((res) => { })
          .catch(() => {})

        this.payment.token = response.token
        console.log('this.payment.token')
        console.log(this.payment.token)
        console.log('this.payment.token')
        this.payment.installments = this.payment.data.installments
      }

      await this.handleResetAlertDetails()

      if(this.user && this.user.role !== 'admin') {
        const log = {
          action: 'PREENCHEU_DADOS_PAGAMENTO'
        }
        await this.createUserActionLogs(log)
      }
      this.loading = false;
      this.$emit('next-step')
    },
    async checkPromotion() {
      const payload = {
        user: this.billingData.document.replace(/\D+/g, ''),
        code: this.discountCoupon,
      }

      const discount = await this.getPromotion(payload)

      if(discount > 0){
        await this.handleSetAlertDetails({
          open: true,
          message: 'Desconto aplicado com sucesso!',
          type: 'success',
        })
      } else {
        await this.handleSetAlertDetails({
          open: true,
          message: 'Cupom inválido!',
          type: 'danger',
        })
      }
      this.promotion.code = this.discountCoupon
      this.handleSetPromotion({code: this.promotion.code})
    },

    async isEligibleForReferralBonusAfterWarranty(){
      const messageError = 'O usuário não atende aos critérios para receber o bônus de indicação!'
      try {
        await this.handleSetEmailReferral(null)
        await this.$store.dispatch('access/updateError', '')
        await this.$store.dispatch('access/updateMessage', '')
        this.loadingIsEligibleForReferralBonusAfterWarranty = true
        const response = await this.handleIsEligibleForReferralBonusAfterWarranty({
          emailReferral: this.emailReferral
        })

        if(!response){
          await this.handleSetEmailReferral(null)
          this.loadingIsEligibleForReferralBonusAfterWarranty = false
          await this.$store.dispatch('access/updateError', messageError)
          return
        }

        const {data, status} = response || {}
        if(status != 200){
          await this.handleSetEmailReferral(null)
          this.loadingIsEligibleForReferralBonusAfterWarranty = false
          await this.$store.dispatch('access/updateError', messageError)
          return
        }

        const {isEligibleForReferralBonus, username} = data || {}
        if(!isEligibleForReferralBonus || !username){
          await this.handleSetEmailReferral(null)
          this.loadingIsEligibleForReferralBonusAfterWarranty = false
          await this.$store.dispatch('access/updateError', messageError)
          return
        }
        await this.$store.dispatch(
          'access/updateMessage',
          `O usuário atende aos critérios para receber o bônus de indicação. <br/> A ativação deste cupom adiciona 2 meses de acesso além dos 12 contratados nesse plano.`
        )
        this.loadingIsEligibleForReferralBonusAfterWarranty = false
        await this.handleSetEmailReferral(username)
      } catch (error) {
        await this.$store.dispatch('access/updateError', messageError)
        this.loadingIsEligibleForReferralBonusAfterWarranty = false
        await this.handleSetEmailReferral(null)
      }
    },
  },
  async mounted() {
    IUGU.setup()
    this.discountCoupon = this.promotion.code
    await this.$store.dispatch('access/updateError', ``)
    await this.$store.dispatch('access/updateMessage', '')
    await this.handleSetEmailReferral(null)
  }
}
</script>

<style lang="scss" scoped>
.payment {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .credit_card-form {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .group, .validity {
      display: grid;
      gap: 16px;
    }
    .group {
      grid-template-columns: 1fr 1fr;
      @media only screen and (max-width: 720px) {
        grid-template-columns: 1fr;
      }
    }
    .validity {
      grid-template-columns: 1fr 1fr 1fr;
      .cc-back {
        display: flex;
        align-items: flex-end;
        // justify-content: center;
        padding: 5px;
        img {
          width: 40px;
          height: auto;
        }
      }
    }
  }

  .coupon-box {
    border: 2px solid var(--blue);
    border-radius: 8px;
    overflow: hidden;

    .coupon-toggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 14px 18px;
      background: #f4fbff;
      border: none;
      color: var(--blue);
      cursor: pointer;
      transition: background 0.2s ease;
      strong {
        font-size: 18px;
      }
      .b-icon {
        font-size: 20px;
      }
      &:hover {
        background: #e6f5ff;
      }
    }

    .coupon-body {
      padding: 0 18px 14px;
    }
  }

  .promotion {
    a {
      color: var(--blue);
      &:hover {
        text-decoration: underline;
      }
    }
    .check-code {
      display: flex;
      align-items: flex-end;
      gap: 8px;
    }
  }

  .buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-top: 24px;

    .nav-btn {
      min-width: 140px;
      padding: 12px 20px;
    }
  }
  label {
    font-size: 14px;
    font-weight: 700;
  }
}

.hits_select {
  text-align: center;
  border: 1px solid #04A8F3;
  padding: 5px;
  border-radius: 6px;
  background: #CBD63E;
  color: #262626;
  font-weight: 700;
  width: 49%;
  font-size: 15px;
}

.hits_no_select {
  border: 1px solid #04A8F3;
  padding: 5px;
  border-radius: 6px;
  background: transparent;
  color: #04A8F3;
  font-weight: 700;
  width: 49%;
  font-size: 15px;
}

.rows_2{
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  flex-wrap: wrap;
  div{
    width: 49%;
    min-width: 300px;
  }
}

</style>
